var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogFormWrapper',{attrs:{"hide-actions":""},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('AddCommune')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }